<div *ngFor="let category of availableCategories" class="category-section">
  <!-- Category Header -->
  <div class="category-header">
    {{ category | translate}}
  </div>

  <!-- Glass Cards for this category -->
  <div class="glass-cards-container">
    <ion-card 
      *ngFor="let glass of getGlassesByCategory(category)" 
      (click)="onSelectGlass(glass)"
      [class.selected]="selectedGlass?.id === glass.id" 
      class="glass-card">

      <div class="glass-icon">  
        <img [src]="getImageForGlazing(glass.glazingCount)" [alt]="glass.name">
      </div>

      <!-- Glass details -->
      <ion-card-header *ngIf="showGlassName">
        <ion-card-title class="glass-product">
          {{ glass.name }}
        </ion-card-title>
      </ion-card-header>

      <ion-card-content class="glass-details">
        <p>{{ 'HEADER_TYPE' | translate }} <strong>{{ getGlazingType(glass.glazingCount) | translate }}</strong></p>
        <p>{{ 'HEADER_UG' | translate }} <strong>{{ glass.ug }} W/m²K</strong></p>
        <p>{{ 'HEADER_G-VALUE' | translate }} <strong>{{ glass.gValue }} %</strong></p>
      </ion-card-content>

      <!-- Info button -->
      <ion-button fill="clear" class="info-button" (click)="onShowInfo($event, glass)">
        <ion-icon src="assets/icons/info-Icon.svg"></ion-icon>
      </ion-button>
    </ion-card>
  </div>
</div>
